import dayjs from "dayjs";
import { FC } from "react";
import style from './style.module.scss'

type RefTransactionProps = {
    referenceData: any;
    title?: string;
};
export const RefranceTransactionData: FC<RefTransactionProps> = (props) => {

    const arr = Object.entries(props.referenceData || {}).map(([key, value]) => ({
        label: key,
        value
    }));

    const formatValue = (key: string, value: any) => {
        if (key === "transaction_amount") return `${value?.amount} ${value?.currency_symbol}`;
        if (key === "transaction_date_time") return dayjs(value).format('DD/MM/YYYY HH:mm:ss');
        return value || '-';
    };

    const referencetranKeyLabel: Record<string, string> = {
        transaction_id: "Transaction ID",
        transaction_amount: "Transaction Amount",
        transaction_date_time: "Transaction Date",
        toll_plaza: "Toll Plaza",
        lane_direction: "Lane Direction"
        // toll_plaza_id: "Toll Plaza ID",

        // bst_transaction_id: "Transaction Id"
    };
    const ref = ["transaction_id", "transaction_amount", "transaction_date_time", "toll_plaza", "lane_direction"]
    return (
        <div className={style.refwrapper}>
            <div style={{ fontSize: "15px", color: "#000000D9", fontWeight: "500", paddingBottom: "10px" }}>
                {props.title}
            </div>
            <div className={style.refrancetrans}>
                {arr.filter(
                    (el: any) =>
                        !["bst_transaction_id", "toll_plaza_id", "complaint_type"].includes(el.label))
                    .sort((x, y) => ref.indexOf(x.label) > ref.indexOf(y.label) ? 1 : -1)
                    .map((e: any, i: number) => (
                        <div key={i} className={style.key}>
                            <div className={style.label}>
                                {referencetranKeyLabel[e.label] || e.label}
                            </div>
                            <span style={{ color: "#333333", textTransform: "capitalize" }}>
                                {formatValue(e.label, e.value)}
                            </span>
                        </div>
                    ))}
            </div>
        </div>
    );
};
